import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import './mobileDrawer.css';
import '../drawerShared/drawer.css';
import { useTheme } from '../../context/ThemeContext';
import { useHistory } from 'react-router-dom';
import NotificationDrawerLink from '../drawerShared/NotificationDrawerLink';
import getUnreadNotifications from '../../utils/getUnreadNotifications';
import { useGetCurrPlayer } from '../../hooks/useGetCurrPlayer';
import FriendRequestsDropdown from '../drawerShared/FriendRequestsDropdown';
import SearchForPlayers from '../drawerShared/SearchForPlayers';
const MobileDrawer = ({ show, onClose, player }) => {
  const { darkTheme } = useTheme();
  //   console.log('Player in MobileDrawer:', player);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (show && player?.token) {
      getUnreadNotifications(player.token).then(setUnreadCount);
    }
  }, [show, player?.token]);

  const onSuccess = () => {};
  const onError = () => {};
  const { data: currPlayer, status } = useGetCurrPlayer(
    onSuccess,
    onError,
    player,
  );

  const friendRequests = currPlayer?.requests?.length || 0;
  const friendRequestPlayers = currPlayer?.requests || [];
  //   console.log('MobileDrawer rendered with:', friendRequests);
  const Logoff = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  const showPresenceDirectoryLink = true; // player-facing

  return (
    <>
      <div
        className={`mobile-drawer${show ? ' open' : ''}`}
        style={{
          background: darkTheme ? '#18181b' : '#fff',
          color: darkTheme ? '#fafafa' : '#222',
          boxShadow: darkTheme ? '2px 0 12px #000a' : '2px 0 12px #0002',
        }}
      >
        <div
          className="drawer-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img
              src={
                player?.data.player.profilePhoto ||
                'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
              }
              alt="avatar"
              style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                border: '2px solid #facc15',
                objectFit: 'cover',
              }}
            />
            <span
              className="trailblazer-gold"
              style={{
                fontWeight: 700,
                fontSize: 20,
                color: darkTheme ? '#facc15' : undefined,
              }}
            >
              JG Trailblazer
            </span>
          </div>
          <button
            onClick={onClose}
            className="close-btn"
            style={{
              color: darkTheme ? '#fafafa' : '#222',
              transition: 'color 0.2s',
            }}
            aria-label="Close"
          >
            ✖
          </button>
        </div>

        <ul className="drawer-links">
          <SearchForPlayers
            player={player}
            autoFocus={show}
            onPlayerClick={() => {
              onClose();
            }}
          />
          <li>
            <Link className="drawer-link-btn" to="/hunts" onClick={onClose}>
              <span className="drawer-link-label">🗺️ Hunts</span>
            </Link>
          </li>
          <li>
            <Link
              className="drawer-link-btn"
              to="/business-directory"
              onClick={onClose}
            >
              <span className="drawer-link-label">🏪 Businesses</span>
            </Link>
          </li>
          {showPresenceDirectoryLink && (
            <li>
              <Link
                className="drawer-link-btn"
                to="/presence-directory"
                onClick={onClose}
              >
                <span className="drawer-link-label">🌐 Presence Directory</span>
              </Link>
            </li>
          )}
          <li>
            <Link
              className="drawer-link-btn"
              to="/leaderboard"
              onClick={onClose}
            >
              <span className="drawer-link-label">🏆 Leaderboard</span>
            </Link>
          </li>
          <li>
            <Link className="drawer-link-btn" to="/rewards" onClick={onClose}>
              <span className="drawer-link-label">🎁 Rewards</span>
            </Link>
          </li>
          <li>
            <Link
              className="drawer-link-btn"
              to="/social-share"
              onClick={onClose}
            >
              <span className="drawer-link-label">📢 Share</span>
            </Link>
          </li>
          <li>
            <Link className="drawer-link-btn" to="/referrals" onClick={onClose}>
              <span className="drawer-link-label">🤝 Referrals</span>
            </Link>
          </li>
          <li>
            <Link className="drawer-link-btn" to="/profile" onClick={onClose}>
              <span className="drawer-link-label">👤 Profile</span>
            </Link>
          </li>{' '}
          <FriendRequestsDropdown
            friendRequests={friendRequests}
            friendRequestPlayers={friendRequestPlayers}
            onPlayerClick={onClose}
          />
          <NotificationDrawerLink unreadCount={unreadCount} onClick={onClose} />
          <li>
            <button
              className="drawer-link-btn"
              onClick={() => {
                if (window.confirm('Ready to blaze out? 🚪')) {
                  onClose();
                  Logoff();
                }
              }}
            >
              🚪 Logout
            </button>
          </li>
        </ul>
      </div>
      {show && <div className="drawer-backdrop" onClick={onClose}></div>}
    </>
  );
};

export default MobileDrawer;
